export * from './honorar-vereinbarung-post-request.interface';
export * from './honorar-vereinbarung-post-response.interface';
export * from './honorar-vereinbarung-post.shapes';
